import { buildScopedI18n } from '../../utils/buildScopedI18n';
import mainLayoutEsCL from './locales/es-CL.json';
import mainLayoutEnUS from './locales/en-US.json';
import mainLayoutPtBR from './locales/pt-BR.json';

export const mainLayoutI18n = buildScopedI18n({
  esCL: mainLayoutEsCL,
  enUS: mainLayoutEnUS,
  ptBR: mainLayoutPtBR,
});
